export const monthlyEngagementSections = [
  { id: "engagement-summary", label: "Summary" },
  { id: "thermostat-engagement", label: "Thermostat" },
  { id: "mobile-app-engagement", label: "Mobile App" },
  { id: "calls", label: "Calls" },
  { id: "partner-level-analytics", label: "Partners" },
] as const

export type MonthlyEngagementSectionId = (typeof monthlyEngagementSections)[number]["id"]

export const getActiveMonthlyEngagementSectionId = (
  sectionIds: readonly MonthlyEngagementSectionId[],
  getTop: (sectionId: MonthlyEngagementSectionId) => number | undefined,
  offset: number,
) => {
  let activeSectionId = sectionIds[0]

  for (const sectionId of sectionIds) {
    const top = getTop(sectionId)

    if (top == null) continue

    if (top - offset <= 0) {
      activeSectionId = sectionId
    }
  }

  return activeSectionId
}
